import { render, staticRenderFns } from "./Relantionship.vue?vue&type=template&id=0ff87aea"
import script from "./Relantionship.vue?vue&type=script&lang=js"
export * from "./Relantionship.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports